(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('Materia', Materia);

    Materia.$inject = ['$resource'];

    function Materia ($resource) {
        var resourceUrl =  'api/materias/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
